import React, { useEffect, useState, useRef } from 'react';
import './SaisieRapport.css';
import { loadUser } from '../../services/api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const MODALITES = {
  "Radiographie conventionnelle": "CR",
  "Radiographie numérique": "DX",
  "Tomodensitométrie (Scanner)": "Scanner",
  "Imagerie par résonance magnétique (IRM)": "IRM",
  "Échographie": "ECHO",
  "Médecine nucléaire": "MN",
  "Tomographie par émission de positons (TEP/PET scan)": "TEP/PET",
  "Angiographie": "ANGIO",
  "Mammographie": "MAMMO",
  "Fluoroscopie": "FLUORO",
  "Endoscopie": "ENDO",
  "Densitométrie osseuse (DXA)": "DENSI",
  "Capture secondaire d'image": "CAPTURE",
  "Autre modalité": "AUTRE",
  "IRM (non standard, mappée vers MR)": "IRM MR",
};

const SaisieRapport = () => {
  const [user, setUser] = useState(null);
  const [rapports, setRapports] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [message, setMessage] = useState('');
  const indicationRef = useRef(null);
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const username = localStorage.getItem('login');

  // ✅ Fonction pour charger les rapports déjà existants
  const fetchUserRapports = async (userId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${username}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = await loadUser(username, token);
        setUser(userData);

        const existingRapports = await fetchUserRapports(userData.id);

        const rapportsMap = {};
        userData.typeExamens.forEach((type) => {
          const rapportExistant = existingRapports.find(r => r.typeExamen.id === type.id);
          rapportsMap[type.id] = {
            indication: rapportExistant?.indication || '',
            resultat: rapportExistant?.resultat || '',
            conclusion: rapportExistant?.conclusion || ''
          };
        });

        setRapports(rapportsMap);
      } catch (error) {
        console.error("Erreur chargement utilisateur ou rapports :", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (indicationRef.current) {
      indicationRef.current.focus();
    }
  }, [currentIndex]);

  const handleChange = (typeId, field, value) => {
    setRapports(prev => ({
      ...prev,
      [typeId]: {
        ...prev[typeId],
        [field]: value
      }
    }));
  };

  const handleSubmit = async (typeId) => {
    const rapport = rapports[typeId];
    try {
      await axios.post(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes`,
        {
          userId: user.id,
          typeExamenId: typeId,
          ...rapport
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage("✅ Rapport enregistré avec succès !");
    } catch (err) {
      console.error(err);
      setMessage("❌ Erreur lors de l'enregistrement.");
    } finally {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleNext = () => {
    if (currentIndex < user.typeExamens.length - 1) {
      setCurrentIndex(prev => prev + 1);
      setMessage('');
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
      setMessage('');
    }
  };

  if (!user) return <p>Chargement...</p>;

  const currentExamen = user.typeExamens[currentIndex];
const currentRapport = rapports[currentExamen.id] || {
  indication: '',
  resultat: '',
  conclusion: ''
};

  return (
    <div className="saisie-container">
      <div className="top-bar">
        <button className="home-button" onClick={() => navigate('/accueil')}>
          <span role="img" aria-label="accueil">🏠</span> Accueil
        </button>
      </div>

      <h1>📝 Saisie des rapports</h1>
      <p className="progress-info">
        Examen {currentIndex + 1} sur {user.typeExamens.length}
      </p>

      <div className="examen-card">
        <h2>{currentExamen.libelle} ({MODALITES[currentExamen.libelle] || 'N/A'})</h2>

        <label>Indication :</label>
        <textarea
          ref={indicationRef}
          value={currentRapport.indication}
          onChange={(e) => handleChange(currentExamen.id, 'indication', e.target.value)}
        />

        <label>Résultat :</label>
        <textarea
          value={currentRapport.resultat}
          onChange={(e) => handleChange(currentExamen.id, 'resultat', e.target.value)}
        />

        <label>Conclusion :</label>
        <textarea
          value={currentRapport.conclusion}
          onChange={(e) => handleChange(currentExamen.id, 'conclusion', e.target.value)}
        />

        <div className="navigation-buttons">
          <button onClick={handlePrevious} disabled={currentIndex === 0}>⬅ Précédent</button>
          <button onClick={() => handleSubmit(currentExamen.id)}>💾 Enregistrer</button>
          <button onClick={handleNext} disabled={currentIndex === user.typeExamens.length - 1}>Suivant ➡</button>
        </div>
      </div>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default SaisieRapport;